/** **********************************************************************************
 * FNV-1a hash   https://en.wikipedia.org/wiki/Fowler%E2%80%93Noll%E2%80%93Vo_hash_function
 * @param str  - We can hash any string, but in this use we concatenate and hash:
 *               IO id, saveIncomplete, placement ID
 *               this allows us to export a placement and import it back safely.
 * @returns      Hash for the given string
 *********************************************************************************** */
export const hashCode = (str) => {
  /* eslint-disable no-bitwise */
  let hash = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
  }
  return hash >>> 0;
  /* eslint-enable no-bitwise */
};
